<div class="dialog">

  <app-header-dialog [iconName]="'noise_control_off'">
    Confirmação
  </app-header-dialog>

  <mat-dialog-content>

    <div class='box'>
      <mat-icon class='dialog-icon'>help</mat-icon>
      <div class='dialog-text'>
        <div class="div-line">
          <div class="div-label">
            Nome:
          </div>
          <div class="div-value">
            {{data.name}}
          </div>
        </div>
        <div class="div-line">
          <div class="div-label">
            Crachá:
          </div>
          <div class="div-value">
            {{data.shortName}}
          </div>
        </div>
        <div class="div-line">
          <div class="div-label">
            Email:
          </div>
          <div class="div-value">
            {{data.email}}
          </div>
        </div>
        <div class="div-line">
          <div class="div-label">
            Celular:
          </div>
          <div class="div-value">
            {{data.cellPhone}}
          </div>
        </div>
        <div class="div-line">
          <div class="div-label">
            CPF:
          </div>
          <div class="div-value">
            {{data.cpf}}
          </div>
        </div>
        <div class="div-line" *ngIf="data.crm">
          <div class="div-label">
            CRM:
          </div>
          <div class="div-value">
            {{data.crm}}
          </div>
        </div>
        <div class="div-line">
          <div class="div-label">
            Categoria:
          </div>
          <div class="div-value">
            {{data.subCategory.name}}
          </div>
        </div>
        <div style="width: 100%; text-align: center; font-weight: bold; padding: 10px;">
          Registrar?
        </div>
      </div>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions fxLayoutAlign="space-between" justify-content='flex-end'>
    <button mat-raised-button mat-dialog-close="close">
      <mat-icon style='color:gray'>highlight_off</mat-icon>
    </button>
    <button type="submit" mat-raised-button mat-dialog-close="ok">
      <mat-icon style='color:green'>check_circle_outline</mat-icon>
    </button>
  </mat-dialog-actions>

</div>